import React, { useState, useEffect } from "react";
import { 
    Form, Input, FormInstance, Cascader, TreeSelect, Spin, Space, Button, 
    Row, Col, Upload, notification, Select, Table, InputNumber, Radio, 
    Tooltip, Tag, Checkbox, Switch, Modal, Popconfirm, Pagination, Empty,
} from "antd";
import { InfoCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    addTemplateNetwork, deleteTemplateNetwork, 
    getTemplateNetwork, getTemplateCertificate,
    getTemplateNetworks, deleteNetwork,
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentWifi = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [proxyType, setProxyType] = useState<String>("None");
    const [encryptionType, setEncryptionType] = useState<String>("None");
    const [entEnum, setEntEnum] = useState<String>("tcp");
    const [fastLaneQos, setFastLaneQos] = useState<number>(0);
    const [acceptEAPTypes, setAcceptEAPTypes] = useState<number[]>([]);
    const [certificates, setCertificates] = useState<any[]>([]);
    const [eapFastInfo, setEapFastInfo] = useState<any>({});
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [wifiList, setWifiList] = useState<any[]>([]);
    const [networkId, setNetworkId] = useState<string>("");
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo();
    }, [])
    const getDataInfo = (index=pageIndex, size=pageSize) => {
        if (platform == "Android") {
            getTemplateNetworks(templateId, {pageIndex: index, pageSize: size}).then((res) => {
                const {dataList, pageIndex, pageSize, totalCount} = res;
                if (dataList.length > 0) {
                    setShowTable(2)
                    setWifiList(dataList);
                    setPageIndex(pageIndex);
                    setPageSize(pageSize);
                    setTotalCount(totalCount);
                } else {
                    setShowTable(1);
                    setWifiList([]);
                }

            })
        } else {
            Promise.all([getTemplateNetworks(templateId, {pageIndex: index, pageSize: size}), getTemplateCertificate(templateId)]).then(([res, res1]) => {
                if (res1 && res1.length > 0) {
                    setCertificates(res1)
                }
                const {dataList, pageIndex, pageSize, totalCount} = res;
                if (dataList.length > 0) {
                    setShowTable(2);
                    setWifiList(dataList);
                    setPageIndex(pageIndex);
                    setPageSize(pageSize);
                    setTotalCount(totalCount);
                } else {
                    setShowTable(1);
                    setWifiList([]);
                }
                
            })
        }

    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            if (isEdit) {
                res.id = networkId;
            }
            if (platform == "Android") {
                addTemplateNetwork(templateId, res).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    setNetworkId("");
                    setIsModalVisible(false);
                    setIsEdit(false);
                    getDataInfo();
                })
            } else {
                res.encryptionType = res.encryptionType.replace("Ent", "");
                if( res.eapClientConfiguration){
                    res.eapClientConfiguration.eapfastProvisionPAC = eapFastInfo.eapfastProvisionPAC??false
                    res.eapClientConfiguration.eapfastProvisionPACAnonymously = eapFastInfo.eapfastProvisionPACAnonymously??false
                    res.eapClientConfiguration.eapfastUsePAC = eapFastInfo.eapfastUsePAC??false
                }
                setLoading(true);
                addTemplateNetwork(templateId, res).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    setLoading(false);
                    setNetworkId("");
                    setIsModalVisible(false);
                    setIsEdit(false);
                    getDataInfo();
                },()=>{
                    setLoading(false);
                });
            }
        })
    }
    const deleteTemplateClick = () => {
        if (platform == "Android") {
            deleteTemplateNetwork(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        } else {
            deleteTemplateNetwork(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        }

    }
    const proxyTypeChange = (e: any) => {
        setProxyType(e);
    }
    const encryptionTypeChange = (e: any) => {
        setEncryptionType(e);
    }
    const hasAcceptEAPType = (nums: number[]) => {

        var index = acceptEAPTypes.findIndex(c => {
            var inx = nums.findIndex(num => num == c);
            return inx != -1
        });
        if (index != -1) {
            return true;
        }

        return false;
    }
    const getCertificateSelect = () => {
        return (
            <Select mode="tags" placeholder={t("未选定身份")}>
                {certificates.map((item: any, index: number) => (
                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                ))}
            </Select>
        );
    }
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
        },
    };
    const formItemLayoutWithOutLabel = {
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
        },
    };

    const onEdit = (res: any) => {
        setNetworkId(res.id);
        setProxyType(res.proxyType);
        if (res.qoSMarkingPolicy) {
            res.fastLaneQos = 1;
            setFastLaneQos(1);
        } else {
            res.fastLaneQos = 0
            setFastLaneQos(0);
        }
        if (res.eapClientConfiguration) {
            if (res.eapClientConfiguration.acceptEAPTypes) {
                setAcceptEAPTypes(res.eapClientConfiguration.acceptEAPTypes);
            }
            setEapFastInfo({
                eapfastProvisionPAC: res.eapClientConfiguration.eapfastProvisionPAC,
                eapfastProvisionPACAnonymously: res.eapClientConfiguration.eapfastProvisionPACAnonymously,
                eapfastUsePAC: res.eapClientConfiguration.eapfastUsePAC,
            })
            res.encryptionType = "Ent" + res.encryptionType;
        }
        setEncryptionType(res.encryptionType);
        dataForm?.setFieldsValue(res);
    }

    const onDeleteNetwork = (networkId: string) => {
        deleteNetwork(templateId, networkId).then(
            () => { notification.success({message: t("移除成功")}) },
            () => { notification.error({message: t("移除失败")}) }
        ).finally(
            () => { getDataInfo(); updateTemplate(); }
        )
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">WiFi</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    // <>
                    //     <Row style={{ margin: "8px 16px 16px 50px", fontSize: "14px" }}>设置网络</Row>
                    //     <Row style={{ margin: "100px 16px 16px 50px", fontSize: "16px" }}>
                    //         <Button onClick={() => { addClick(); gaEvent("templateContentWifi", "onClick", "addClick") }} type="primary">
                    //             添加规则
                    //         </Button>
                    //     </Row>
                    // </>
                    (<div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置网络")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentWifi", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>)
                )}
                {showTable == 2 && (
                    <>
                        

                        <div className="tAr">
                            <Button 
                                type="primary" 
                                onClick={() => { 
                                    setIsModalVisible(true);
                                    dataForm.resetFields();
                                }}
                            ><PlusOutlined />{t("添加WiFi")}</Button>
                        </div>
                        <div style={{width: "100%"}}>
                            <Table 
                                dataSource={wifiList} 
                                rowKey={(row) => row.id} 
                                pagination={false}
                                style={{ width: "100%" ,marginLeft:8}}
                                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                            >
                                <Column title={t("WiFi名称")} key="wiFiSSID" dataIndex="wiFiSSID"></Column>
                                <Column title={t("自动链接")} key="autoJoin" dataIndex="autoJoin"
                                    render={(v) => v ? t("是") : t("否")}
                                ></Column>
                                <Column title={t("隐藏网络")} key="isHidden" dataIndex="isHidden"
                                    render={(v) => v ? t("是") : t("否")}
                                ></Column>
                                <Column title={t("禁用MAC地址随机化")} key="disableAssociationMACRandomization" dataIndex="disableAssociationMACRandomization"
                                    render={(v) => v ? t("是") : t("否")}
                                ></Column>
                                <Column title={t("安全性")} key="encryptionType" dataIndex="encryptionType"
                                    render={(v) => v === "None" ? "无" : v}
                                ></Column>
                                <Column
                                    title={t("操作")}
                                    key="id"
                                    dataIndex="id"
                                    render={(value, row, index) => {
                                        return (
                                            <>
                                                <Button type="link" onClick={() => { 
                                                    onEdit(row);
                                                    setIsModalVisible(true); 
                                                    setIsEdit(true);
                                                }}>{t("编辑")}</Button>
                                                <Popconfirm title={`${t("确认移除")}?`} onConfirm={() => { onDeleteNetwork(value) }}>
                                                    <Button type="text" danger>{t("移除")}</Button>
                                                </Popconfirm>
                                            </>
                                        )
                                    }}></Column>
                            </Table>
                            <Pagination
                                style={{ textAlign: "right", marginTop: "20px" }}
                                pageSize={pageSize}
                                current={pageIndex}
                                total={totalCount}
                                showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
                                onChange={(page, pageSize) => { getDataInfo(page, pageSize) }}
                                onShowSizeChange={(current, size) => { getDataInfo(current, size) }}
                            ></Pagination>
                        </div>

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "80%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { console.log("点击保存！") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentWifi", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
            <Modal
                maskClosable={false}
                open={isModalVisible}
                confirmLoading={loading}
                title={`${isEdit ? t('编辑WiFi') : t('添加WiFi')}`}
                width="650px"
                onOk={addTemplateClick}
                onCancel={() => { 
                    setIsModalVisible(false);
                    setIsEdit(false);
                    setProxyType("None");
                    setEncryptionType("None");
                    dataForm.resetFields();
                }}
                okText={t("确认")}
                cancelText={t("取消")}
            >
                <Form
                    style={{ width: "90%", marginTop: 36, marginLeft: 45 }}
                    layout="vertical"
                    form={dataForm}
                    labelCol={{ span: 24 }}
                    initialValues={{
                        proxyType: "None", 
                        encryptionType: "None", 
                        autoJoin: true, 
                        isHidden: false, 
                        disableAssociationMACRandomization: false, 
                        isHotspot: false, 
                        eapClientConfiguration: {
                            isHidden: false, 
                            tlsMaximumVersion: "", 
                            tlsMinimumVersion: "", 
                            eapsimNumberOfRANDs: null, 
                            tlsTrustedServerNames: [""]
                        }, 
                        qoSMarkingEnabled: {
                            qoSMarkingAppleAudioVideoCalls: true,
                            qoSMarkingEnabled: true
                        }
                    }}
                >

                    <Item label={t("WiFi名称")} name="wiFiSSID" rules={[{ required: true }]}>
                        <Input></Input>
                    </Item>

                    <Item label={t("自动链接WiFi")} name="autoJoin" rules={[{ required: true }]}>
                        <Radio.Group >
                            <Radio value={true}>{t("是")}</Radio>
                            <Radio value={false}>{t("否")}</Radio>
                        </Radio.Group>
                    </Item>


                    <Item label={t("隐藏网络")} name="isHidden" rules={[{ required: true }]}>
                        <Radio.Group >
                            <Radio value={true}>{t("是")}</Radio>
                            <Radio value={false}>{t("否")}</Radio>
                        </Radio.Group>
                    </Item>

                    <Item label={t("禁用MAC地址随机化")} name="disableAssociationMACRandomization" rules={[{ required: true }]}>
                        <Radio.Group >
                            <Radio value={true}>{t("是")}</Radio>
                            <Radio value={false}>{t("否")}</Radio>
                        </Radio.Group>
                    </Item>


                    <Item label={t("代理设置")} name="proxyType" rules={[{ required: true }]}>
                        <Select onChange={proxyTypeChange} >
                            <Select.Option value="None">{t("无")}</Select.Option>
                            <Select.Option value="Manual">{t("手动")}</Select.Option>
                            <Select.Option value="Auto">{t("自动")}</Select.Option>
                        </Select>
                    </Item>

                    {proxyType == "Auto" && (

                        <Item label={t("代理服务器URL")} name="proxyServer" extra={<><InfoCircleOutlined /> {t("用于取回代理设置的URL")}</>} >
                            <Input></Input>
                        </Item>

                    )}
                    {proxyType == "Manual" && (
                        <>

                            <Item label={t("服务器和端口")} rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("用于取回代理设置的URL")}</>}>
                                <Input.Group style={{ width: '100%' }} compact>
                                    <Item noStyle name="proxyServer">
                                        <Input style={{ width: '70%' }} placeholder={t("必填")} />

                                    </Item>
                                    <span style={{ width: '5%', textAlign: "center", fontSize: "20px" }} >:</span>
                                    <Item noStyle name="proxyServerPort">
                                        <  InputNumber style={{ width: '25%' }} />
                                    </Item>
                                </Input.Group>
                            </Item>



                            <Item label={t("用户名")} name="proxyUsername" extra={<><InfoCircleOutlined /> {t("用于连接到代理的用户名")}</>}>
                                <Input placeholder={t("在设备上设置")}></Input>
                            </Item>


                            <Item label={t("密码")} name="proxyPassword" extra={<><InfoCircleOutlined /> {t("用于鉴定代理的密码")}</>}>
                                <Input.Password></Input.Password>
                            </Item>

                        </>
                    )}

                    <Item label={t("安全性")} name="encryptionType" rules={[{ required: true }]}>
                        <Select onChange={encryptionTypeChange}>
                            <Select.OptGroup label={t("无")}>
                                <Select.Option key="None" value="None">{t("无")}</Select.Option>
                            </Select.OptGroup>
                            <Select.OptGroup label={t("个人")}>
                                <Select.Option value="WEP">WEP</Select.Option>
                                <Select.Option value="WPA2">WPA/WPA2-Personal</Select.Option>
                                <Select.Option value="WPA3">WPA3-personal</Select.Option>
                                <Select.Option value="Any">{t("任一(个人级)")}</Select.Option>
                            </Select.OptGroup>
                            <Select.OptGroup label={t("企业")}>
                                <Select.Option value="EntWEP">{t("动态")} WEP</Select.Option>
                                <Select.Option value="EntWPA">WPA/WPA2 {t("企业级")}</Select.Option>
                                <Select.Option value="EntWPA2">WPA2 {t("企业级")}({t("iOS8或更高版本,AppleTV除外")})</Select.Option>
                                <Select.Option value="EntWPA3">WPA3 {t("企业级")}({t("iOS13或更高版本")})</Select.Option>
                                <Select.Option value="EntAny">{t("任一(企业级)")}</Select.Option>
                            </Select.OptGroup>
                        </Select>
                    </Item>

                    {(encryptionType == "WEP" || encryptionType == "WPA2" || encryptionType == "WPA3" || encryptionType == "Any") && (

                        <Item label={t("密码")} name="password" rules={[{ required: true }]}>
                            <Input.Password></Input.Password>
                        </Item>

                    )}
                    {(encryptionType == "EntWEP" || encryptionType == "EntWPA" || encryptionType == "EntWPA2" || encryptionType == "EntWPA3" || encryptionType == "EntAny") && (
                        <>
                            <Row>
                                <Col span={16} style={{ textAlign: "center", marginBottom: 16 }}>
                                    <Radio.Group value={entEnum} onChange={(e: any) => { setEntEnum(e.target.value) }}>
                                        <Radio.Button value="tcp">{t("协议")}</Radio.Button>
                                        <Radio.Button value="trust">{t("信任")}</Radio.Button>
                                    </Radio.Group>
                                </Col>
                            </Row>

                            <Row style={{ width: "100%" }} hidden={entEnum != "tcp"}>

                                <Row style={{ width: "100%" }}>
                                    <Col span={16}>
                                        <Item label={t("接受的EAP类型")} name={["eapClientConfiguration", "acceptEAPTypes"]}>
                                            <Checkbox.Group onChange={(e: any) => setAcceptEAPTypes(e)}>
                                                <Row gutter={[20, 20]}>
                                                    <Col span={6}>
                                                        <Checkbox value={13}>TLS</Checkbox>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Checkbox value={17}>LEAP</Checkbox>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Checkbox value={43}>EAP-FAST</Checkbox>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Checkbox value={23}>EAP-AkA</Checkbox>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Checkbox value={21}>TTLS</Checkbox>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Checkbox value={25}>PEAP</Checkbox>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Checkbox value={18}>EAP-SIM</Checkbox>
                                                    </Col>
                                                </Row>
                                            </Checkbox.Group >
                                        </Item>
                                    </Col>
                                </Row>
                                {hasAcceptEAPType([17, 21, 25]) && (
                                    <div style={{ width: "100%" }}>


                                        <Item label={t("用户名")} name={["eapClientConfiguration", "userName"]} extra={<><InfoCircleOutlined /> {t("用于接入无线网络的用户名")}</>}>
                                            <Input></Input>
                                        </Item>

                                        <Item label={t("使用单次连接密码")} name={["eapClientConfiguration", "isHidden"]} extra={<><InfoCircleOutlined /> {t("每次连接时,均要求输入密码,并在鉴定时发送")}</>}>
                                            <Radio.Group>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>


                                        <Item label={t("密码")} name={["eapClientConfiguration", "userPassword"]} extra={<><InfoCircleOutlined /> {t("给定用户所使用的密码")}</>}>
                                            <Input.Password></Input.Password>
                                        </Item>

                                    </div>
                                )}
                                {hasAcceptEAPType([43]) && (
                                    <div style={{ width: "100%" }}>

                                        <Item label={t("使用PAC")} name={["eapClientConfiguration", "eapfastUsePAC"]}>
                                            <Switch checked={eapFastInfo.eapfastUsePAC} onChange={(e: any) => setEapFastInfo({ eapfastUsePAC: e })}></Switch>
                                        </Item>

                                        <Item label={t("预置PAC")} name={["eapClientConfiguration", "eapfastProvisionPAC"]}>
                                            <Switch checked={eapFastInfo.eapfastProvisionPAC}
                                                onChange={(e: any) => { setEapFastInfo({ eapfastProvisionPAC: e, eapfastUsePAC: true }) }}
                                                disabled={!eapFastInfo.eapfastUsePAC}></Switch>
                                        </Item>


                                        <Item label={t("匿名预置PAC")} name={["eapClientConfiguration", "eapfastProvisionPACAnonymously"]}>
                                            <Switch checked={eapFastInfo.eapfastProvisionPACAnonymously}
                                                onChange={(e: any) => { setEapFastInfo({ eapfastProvisionPACAnonymously: e, eapfastUsePAC: true, eapfastProvisionPAC: true }) }} disabled={!eapFastInfo.eapfastProvisionPAC}></Switch>
                                        </Item>

                                    </div>
                                )}
                                {hasAcceptEAPType([21, 43, 25]) && (
                                    <div style={{ width: "100%" }}>

                                        <Item label={t("外部身份")} name={["eapClientConfiguration", "outerIdentity"]} extra={<><InfoCircleOutlined /> {t("外部公开身份(适用于TTLS,PEAP和EAP-FAST)")}</>}>
                                            <Input></Input>
                                        </Item>


                                    </div>
                                )}
                                {hasAcceptEAPType([21]) && (
                                    <div style={{ width: "100%" }}>

                                        <Item label={t("内部鉴定")} name={["eapClientConfiguration", "ttlsInnerAuthentication"]} extra={<><InfoCircleOutlined /> {t("鉴定协议(仅用于TTLS)")}</>}>
                                            <Select>
                                                <Select.Option value="None">{t("操作系统默认")}</Select.Option>
                                                <Select.Option value="PAP">PAP</Select.Option>
                                                <Select.Option value="CHAP">CHAP</Select.Option>
                                                <Select.Option value="MSCHAP">MSCHAP</Select.Option>
                                                <Select.Option value="MSCHAPv2">MSCHAPv2</Select.Option>
                                                <Select.Option value="EAP">EAP({t("iOS 9和OSx 10.11中新增")})</Select.Option>
                                            </Select>
                                        </Item>

                                    </div>

                                )}
                                {hasAcceptEAPType([13, 21, 25, 43]) && (
                                    <div style={{ width: "100%" }}>

                                        <Item label={t("身份证书")} name={["eapClientConfiguration", "tlsTrustedCertificates"]} extra={<><InfoCircleOutlined /> {t("无线网络的客户端身份。TLS必须使用。会启用TTLS,EAP-FAST和PEAP的双重认证")}</>}>
                                            {getCertificateSelect()}
                                        </Item>


                                        <Item label={t("TLS最低版本")} name={["eapClientConfiguration", "tlsMinimumVersion"]}>
                                            <Select>
                                                <Select.Option value="">{t("无")}</Select.Option>
                                                <Select.Option value="1.0">1.0</Select.Option>
                                                <Select.Option value="1.1">1.1</Select.Option>
                                                <Select.Option value="1.2">1.2</Select.Option>
                                            </Select>
                                        </Item>


                                        <Item label={t("TLS最高版本")} name={["eapClientConfiguration", "tlsMaximumVersion"]}>
                                            <Select>
                                                <Select.Option value="">{t("无")}</Select.Option>
                                                <Select.Option value="1.0">1.0</Select.Option>
                                                <Select.Option value="1.1">1.1</Select.Option>
                                                <Select.Option value="1.2">1.2</Select.Option>
                                            </Select>
                                        </Item>

                                    </div>
                                )}

                                {hasAcceptEAPType([18]) && (
                                    <div style={{ width: "100%" }}>
                                        <Item label={t("允许两个RAND值")} name={["eapClientConfiguration", "eapsimNumberOfRANDs"]} extra={<><InfoCircleOutlined /> {t("允许对仅提供两个RAND值的服务进行鉴定")}</>}>
                                            <Radio.Group>
                                                <Radio value={2}>{t("是")}</Radio>
                                                <Radio value={null}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>

                                    </div>
                                )}
                            </Row>
                            <div style={{ width: "100%" }} hidden={entEnum != "trust"}>

                                <Item label={t("身份证书")} name={["eapClientConfiguration", "tlsTrustedCertificates"]} extra={<><InfoCircleOutlined /> {t("证书获取信任/通过鉴定")}</>}>
                                    {getCertificateSelect()}
                                </Item>

                                <Row style={{ width: "100%" }}>
                                    <Col span={16}>
                                        <Form.List name={["eapClientConfiguration", "tlsTrustedServerNames"]} >
                                            {(fields, { add, remove }, { errors }) => (
                                                <>
                                                    {fields.map((field, index) => (
                                                        <Form.Item
                                                            labelCol={{ span: 8 }}
                                                            label={index === 0 ? t('可信的服务器证书名称') : ''}
                                                            {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                                                            required={false}
                                                            key={field.key}
                                                        >
                                                            <Row>
                                                                <Col span={18}>
                                                                    <Form.Item noStyle {...field} extra={<><InfoCircleOutlined /> {t("证书名称应来自鉴定服务器")}</>}>
                                                                        <Input placeholder={t("通用证书名称")} style={{ width: "100%" }} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col offset={2} span={4}>
                                                                    {fields.length > 1 ? (
                                                                        <MinusCircleOutlined
                                                                            style={{ width: "20%" }}
                                                                            className="dynamic-delete-button"
                                                                            onClick={() => remove(field.name)}
                                                                        />
                                                                    ) : null}
                                                                </Col>
                                                            </Row>


                                                        </Form.Item>
                                                    ))}
                                                    <Form.Item  {...formItemLayoutWithOutLabel}>
                                                        <Button
                                                            type="dashed"
                                                            onClick={() => add()}
                                                            style={{ width: '60%' }}
                                                            icon={<PlusOutlined />}
                                                        >
                                                            {t("添加")}
                                                        </Button>
                                                    </Form.Item>
                                                    <Form.ErrorList errors={errors} />
                                                </>
                                            )}
                                        </Form.List>
                                    </Col>
                                    {/* <Col span={8} >
                                        <p style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}><InfoCircleOutlined />&nbsp;&nbsp;&nbsp;证书名称应来自鉴定服务器</p>
                                    </Col> */}
                                </Row>
                            </div>

                            <Item label={t("网络类型")} name="isHotspot" extra={<><InfoCircleOutlined /> {t("配置网络使其显示为旧热点")}</>}>
                                <Radio.Group >
                                    <Radio value={true}>{t("标准")}</Radio>
                                    <Radio value={false}>{t("旧热点")}</Radio>
                                </Radio.Group>
                            </Item>


                            <Item label={t("Fast Lane Qos标记")} name="fastLaneQos">
                                <Select defaultValue={0} onChange={(e: any) => { setFastLaneQos(e) }}>
                                    <Select.Option value={0}>{t("不限制Qos标记")}</Select.Option>
                                    <Select.Option value={1}>{t("限制Qos标记")}</Select.Option>
                                </Select>
                            </Item>

                            {fastLaneQos == 1 && (
                                <>

                                    <Item label={t("启用Qos标记")} name={["qoSMarkingPolicy", "qoSMarkingEnabled"]} initialValue={true} >
                                        <Radio.Group >
                                            <Radio value={true}>{t("是")}</Radio>
                                            <Radio value={false}>{t("否")}</Radio>
                                        </Radio.Group>
                                    </Item>


                                    <Item label={t("允许Apple音频/视频呼叫")} name={["qoSMarkingPolicy", "qoSMarkingAppleAudioVideoCalls"]} initialValue={true} >
                                        <Radio.Group>
                                            <Radio value={true}>{t("是")}</Radio>
                                            <Radio value={false}>{t("否")}</Radio>
                                        </Radio.Group>
                                    </Item>
                                </>
                            )}
                        </>
                    )}

                </Form>
            </Modal>
        </div>
    </>);
};